import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './WarehousePage.css';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import { QuestionCircle, Printer, CheckCircle } from 'react-bootstrap-icons';
import Modal from 'react-bootstrap/Modal';

function WarehousePage() {
  const inputEl = useRef("");
  const [searchTerm, setSearchTerm ] = useState("");
  const [searchResults,setSearchResult] = useState([]);
  const [warehouseModal, setWarehouseModal] = useState(false);
  const handleWHModal = () => {
    setWarehouseModal(!warehouseModal);
  }
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: 'FETCH_WAREHOUSE' });
    dispatch({ type: 'FETCH_CLIENTS' });
    dispatch({ type: 'FETCH_REQUESTS' })
  }, []);

  // get the warehouse reducer
  const warehouse = useSelector((store) => store.warehouseReducer);

  // get the client reducer
  const clients = useSelector((store) => store.clientReducer);

  console.log("wareshouse reducer -------------------", warehouse);

  function addDashes(phone) {
    return phone.slice(0, 3) + "-" + phone.slice(3, 6) + "-" + phone.slice(6);
  }

  const closeClient = (id) => {
    console.log("wareshoue id", id);
    dispatch({ type: 'CLOSE_CLIENT', payload: id })
  }

  function timeConverter(timestamp) {
    if (timestamp) {
      const time = new Date(timestamp);
      const fd = new Intl.DateTimeFormat('en-us').format(time);
      return fd.toString();
    }
    else { return; }
  }

  function timeConverter2(timestamp) {
    if (timestamp) {
      const time = new Date(timestamp);
      const options = { hour: "numeric", minute: "numeric" }
      const fd = new Intl.DateTimeFormat('en-us', options).format(time);
      return fd.toString();
    }
    else { return; }
  }

  function printDiv() {
    var printContents = document.getElementById("printableArea").innerHTML;
    var originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    document.body.innerHTML = originalContents;
    location.reload();
  }

      const searchHandler = (searchTerm) =>{
        setSearchTerm(searchTerm);
        if(searchTerm !==""){
            const newClientList = warehouse.filter((warehouse)=>{
              return Object.values(warehouse).join(" ").toLowerCase().includes(searchTerm.toLowerCase());
            })
             
            setSearchResult(newClientList);
            console.log("test"+searchResults);
        }
        else{
       
            setSearchResult(warehouse);
                console.log("test"+searchResults);
        }
        }

    const getSearchTerm = () =>{
        searchHandler(inputEl.current.value);
    }
        
  return (
    <>
      <Modal
        size="md"
        show={warehouseModal}
        onHide={() => handleWHModal()}
        animation={false}
      >
        <Modal.Header>
          <Modal.Title className="w-100 text-center">
            INSTRUCTIONS
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p>The warehouse table displays all approved clients and their scheduled time to come to the warehouse. </p>
          <p>The print button below
          will print only the table.&nbsp;&nbsp;<Printer type="button"
              color="#3898ac" size={30} /></p>
          <p>Once the client has finished going to the warehouse and picked up their furniture, press the <CheckCircle type="button" color="green" size={30} /> button
          to remove the client from the table. The client information will then move to the closed tab on the Home page.</p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="primary"
            onClick={handleWHModal}
          >CLOSE</Button>
        </Modal.Footer>
      </Modal>


      <Container fluid>
        <Row className="ml-3 mb-3 d-flex justify-content-left align-middle"><h3 id="warehouseHeader">WAREHOUSE</h3><QuestionCircle
          className="ml-3 mt-0"
          type="button"
          color="#d1a228" size={30}
          onClick={handleWHModal} />
          <Printer
            type="button"
            className="ml-3 mt-0"
            color="#3898ac" size={30}
            onClick={() => printDiv()}
          />
        </Row>
        <div id='wh-table-div'>
          <div id="printableArea">

             <input ref={inputEl} size="40" type="text" value={searchTerm} onChange={getSearchTerm} placeholder="type to search"></input>



            <Table striped bordered hover>
              <thead id="warehouseTable">
                <tr>
                   <th scope="col">Appt. Date</th>
                  <th scope="col">Referral Date</th>
                  <th scope="col">Referral Agency Name</th>
                  <th scope="col">Staff Member Name</th>
                  <th scope="col">Client Name</th>
                  <th scope="col">Client Phone Number</th>
                  <th scope="col">Special Instructions</th>
                  <th scope="col"># in Home</th>
                  <th scope="col">Requested Items</th>
                 
                  <th scope="col">Close</th>
                </tr>
              </thead>
              <tbody>

                {
                  searchTerm.length < 1?
                  <>
                {warehouse.map(warehouse => (
                  <tr key={warehouse.warehouse_id}>
                    <td scope="row" className="text-center">{timeConverter2(warehouse.appt_date)} {timeConverter(warehouse.appt_date)}</td>
                    <td scope="row" className="text-center">{timeConverter(warehouse.referral_date)}</td>
                    <td scope="row" className="text-center">{warehouse.referral_agency}</td>
                    <td scope="row" className="text-center">{warehouse.staff_name}</td>
                    <td scope="row" className="text-center">{warehouse.name}</td>
                    <td scope="row" className="text-center">{addDashes(warehouse.phone)}</td>
                    <td scope="row" className="text-center">{warehouse.special_instructions}</td>
                    <td scope="row" className="text-center">{warehouse.household_members.length}</td>
                    <td scope="row" className="text-center">{warehouse.request_items}</td>
                    <td scope="row" className="text-center"><CheckCircle size={30} color="green" type="button" onClick={() => { closeClient(warehouse.warehouse_id) }} /></td>
                  </tr>
                ))}
                </>
                :
                <>
                {searchResults.map(warehouse => (
                  <tr key={warehouse.warehouse_id}>
                    <td scope="row" className="text-center">{timeConverter2(warehouse.appt_date)} {timeConverter(warehouse.appt_date)}</td>
                    <td scope="row" className="text-center">{timeConverter(warehouse.referral_date)}</td>
                    <td scope="row" className="text-center">{warehouse.referral_agency}</td>
                    <td scope="row" className="text-center">{warehouse.staff_name}</td>
                    <td scope="row" className="text-center">{warehouse.name}</td>
                    <td scope="row" className="text-center">{addDashes(warehouse.phone)}</td>
                    <td scope="row" className="text-center">{warehouse.special_instructions}</td>
                    <td scope="row" className="text-center">{warehouse.household_members.length}</td>
                    <td scope="row" className="text-center">{warehouse.request_items}</td>
                    <td scope="row" className="text-center"><CheckCircle size={30} color="green" type="button" onClick={() => { closeClient(warehouse.warehouse_id) }} /></td>
                  </tr>
                ))}
                </>
            }


              </tbody>
            </Table>
          </div>
        </div>
      </Container>
    </>
  )
}

export default WarehousePage